import React from 'react';

import {
  BPDetailsWrapper,
  BPItem,
  IconWrapper,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  ModalTitle,
  Paragraph,
} from './styles';
import { useI18n } from '../../../../hooks/useI18n';
import { TranslationKeys } from '../../../../i18n/locales/defaultResources';
import ActionButton from '../../../components/ActionButton/ActionButton';
import DefaultBPIcon from '../../../../assets/icons/DefaultBPIcon';
import { BusinessPartnerSelectorItem } from '../../bp/BusinessPartnerSelector/types';

interface OnSwitchingBPWarningModalProps {
  isOpen: boolean;
  bp: BusinessPartnerSelectorItem;
  onClose: () => void;
}

const OnSwitchingBPWarningModal: React.FC<OnSwitchingBPWarningModalProps> = ({
  isOpen,
  bp,
  onClose,
}) => {
  const { t } = useI18n();

  return (
    isOpen && (
      <ModalOverlay>
        <ModalContent>
          <ModalHeader>
            <ModalTitle>
              {t(TranslationKeys.on_switching_BP_warning_modal_title)}
            </ModalTitle>
            <BPItem>
              <IconWrapper>
                <DefaultBPIcon color="grey" />
              </IconWrapper>
              <BPDetailsWrapper>
                <span>{bp.businessPartnerNumber}</span>
                <span>{bp.businessPartnerDisplayName}</span>
              </BPDetailsWrapper>
            </BPItem>
          </ModalHeader>
          <ModalBody>
            <Paragraph>
              {t(TranslationKeys.on_switching_BP_warning_modal_paragraph_1)}
            </Paragraph>
            <Paragraph>
              {t(TranslationKeys.on_switching_BP_warning_modal_paragraph_2)}
            </Paragraph>
            <Paragraph>
              {t(TranslationKeys.on_switching_BP_warning_modal_paragraph_3)}
            </Paragraph>
            <Paragraph>
              {t(TranslationKeys.on_switching_BP_warning_modal_paragraph_4)}
            </Paragraph>
            <Paragraph>
              {t(TranslationKeys.on_switching_BP_warning_modal_paragraph_5)}
            </Paragraph>
          </ModalBody>
          <ModalFooter>
            <ActionButton
              variant="accept-blue"
              buttonText={t(
                TranslationKeys.on_switching_BP_warning_modal_close_button
              )}
              onClickAction={onClose}
            />{' '}
          </ModalFooter>
        </ModalContent>
      </ModalOverlay>
    )
  );
};

export default OnSwitchingBPWarningModal;
